import React from 'react';
import { useIntl } from 'react-intl';
import { ProgressLinear } from '@americanexpress/dls-react';
import styles from './AssertionVerify.scss';

const AssertionVerify = () => {
  const intl = useIntl();

  return (
    <div className={styles['passkey-assertion__loading']}>
      <h2 className={styles['passkey-assertion__verifying-title']}>
        {intl.formatMessage({ id: 'passkeyAssertion.verifyingTitle' })}
      </h2>
      <p className={styles['passkey-assertion__description']}>
        {intl.formatMessage({ id: 'passkeyAssertion.verifyingMessage' })}
      </p>
      <p className={styles['passkey-assertion__verifying-status']}>
        {intl.formatMessage({ id: 'passkeyAssertion.verifyingStatus' })}
      </p>
      <ProgressLinear />
    </div>
  );
};

export default AssertionVerify;
